import { useSuspenseQuery } from "@tanstack/react-query";
import { get, PaginatedResponse } from "@/api/api";
import { OpportunityStatus } from "@/opportunity/opportunity";

const useOpportunityStatuses = () => {
  return useSuspenseQuery({
    queryKey: [
      "opportunity-statuses"
    ],
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await get<PaginatedResponse<OpportunityStatus>>(`opportunity-statuses/`);
      return res.results;
    },
  });
}

export const useStatusDetails = (status: string): OpportunityStatus => {
  const { data: statusOptions } = useOpportunityStatuses();

  const matchingStatusOption = statusOptions.find((statusOption) => statusOption.name === status);
  if (!matchingStatusOption) {
    throw Error(`status ${status} not found in available options`)
  }

  return matchingStatusOption;
}

export default useOpportunityStatuses;